import { createStyles } from '@mantine/core';

import { TIMEOUT } from '../constants';

export const useStyles = createStyles(
  (
    theme,
    {
      hasWrapperContent,
      fullScreen,
      isClosing,
      isOpen,
    }: {
      hasWrapperContent: boolean;
      fullScreen?: boolean;
      isClosing: boolean;
      isOpen: boolean;
    }
  ) => ({
    modal: {
      position: 'relative',
      backgroundColor: hasWrapperContent ? theme.colors.gray[0] : theme.white,
      borderRadius: theme.other.spacing._24,
      alignSelf: 'center',
      justifySelf: 'center',
      display: isOpen || isClosing ? 'flex' : 'none',
      flexDirection: 'column',

      ...(hasWrapperContent
        ? {
            [theme.fn.largerThan('sm')]: {
              padding: theme.other.spacing._12,
              borderRadius: theme.other.spacing._32,
            },
            paddingTop: 0,
            backgroundColor: theme.colors.gray[0],
          }
        : {
            backgroundColor: theme.white,
          }),

      ...(fullScreen
        ? {
            width: '100%',
            height: '100dvh',
            alignSelf: 'stretch',
            borderRadius: 0,
          }
        : {}),

      ...(fullScreen
        ? {
            '&.enter': {
              opacity: 0,
            },
            '&.enter-active': {
              transition: `opacity ${TIMEOUT}ms ease-in-out`,
              opacity: 1,
            },
            '&.enter-done': {
              opacity: 1,
            },
            '&.exit': {
              opacity: 1,
            },
            '&.exit-active': {
              opacity: 0,
              transition: `opacity ${TIMEOUT}ms ease-in-out`,
            },
            '&.exit-done': {
              opacity: 0,
            },
          }
        : {
            marginTop: theme.other.spacing._32,
            marginBottom: theme.other.spacing._32,

            '&.enter': {
              transform: `translateY(-${theme.other.spacing._32}px)`,
              opacity: 0,
            },
            '&.enter-active': {
              transition: `transform ${TIMEOUT}ms ease-in-out, opacity ${TIMEOUT}ms ease-in-out`,
              transform: `translateY(0)`,
              opacity: 1,
            },
            '&.enter-done': {
              transform: `translateY(0)`,
              opacity: 1,
            },
            '&.exit': {
              transform: `translateY(0)`,
              opacity: 1,
            },
            '&.exit-active': {
              transform: `translateY(${theme.other.spacing._32}px)`,
              opacity: 0,
              transition: `transform ${TIMEOUT}ms ease-in-out, opacity ${TIMEOUT}ms ease-in-out`,
            },
            '&.exit-done': {
              transform: `translateY(-${theme.other.spacing._32}px)`,
              opacity: 0,
            },
          }),
    },
    closeButton: {
      position: 'absolute',
      top: theme.other.spacing._16,
      right: theme.other.spacing._16,
      backgroundColor: theme.colors.gray[0],
      borderRadius: '100em',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.other.spacing._4,
      cursor: 'pointer',
      transition: 'opacity 150ms ease-in-out',
      zIndex: 5,

      '&:hover': {
        opacity: 0.5,
      },
    },
    wrapperContent: {},
    containerInner: {
      position: 'relative',
      height: '100%',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      ...(fullScreen
        ? {
            overflowY: 'auto', // Allow content scrolling for fullscreen modals
            flex: 1,
            paddingBottom: theme.other.spacing._40,
          }
        : {
            maxHeight: '95vh', // Prevent modal from taking full screen (non-fullscreen only)
            overflowY: 'auto', // Allow content scrolling when needed (non-fullscreen only)
          }),
      ...(hasWrapperContent
        ? {
            backgroundColor: theme.white,
            borderRadius: theme.other.spacing._24,
          }
        : {}),
    },
  })
);
